import services from "../../../http/index";
import * as types from "./mutations-types";

export const ActionDoGetContractTemplates = ({ commit }) => {
    commit(types.SET_LOADING, true);
    return services.api.request({
        url: "contract-templates",
        method: "get"
    }).then(response => {
        commit(types.SET_CONTRACT_TEMPLATES, response.data.data || []);
        commit(types.SET_LOADING, false);
        return response.data;
    }).catch(error => {
        commit(types.SET_LOADING, false);
        throw error;
    });
};

export const ActionDoGetContractTemplateByService = ({ commit }, serviceId) => {
    commit(types.SET_LOADING, true);
    return services.api.request({
        url: `contract-templates/service/${serviceId}`,
        method: "get"
    }).then(response => {
        commit(types.SET_CURRENT_TEMPLATE, response.data.data || null);
        commit(types.SET_LOADING, false);
        return response.data;
    }).catch(error => {
        commit(types.SET_LOADING, false);
        if (error.response && error.response.status === 404) {
            commit(types.SET_CURRENT_TEMPLATE, null);
            return { data: null };
        }
        throw error;
    });
};

export const ActionDoSaveContractTemplate = ({ commit }, payload) => {
    commit(types.SET_LOADING, true);
    return services.api.request({
        url: "contract-templates",
        method: "post",
        data: payload
    }).then(response => {
        commit(types.UPDATE_TEMPLATE, response.data.data);
        commit(types.SET_LOADING, false);
        return response.data;
    }).catch(error => {
        commit(types.SET_LOADING, false);
        throw error;
    });
};

export const ActionDoDeleteContractTemplate = ({ commit, state }, templateId) => {
    commit(types.SET_LOADING, true);
    return services.api.request({
        url: `contract-templates/${templateId}`,
        method: "delete"
    }).then(response => {
        const templates = state.contract_templates.filter(t => t.id !== templateId);
        commit(types.SET_CONTRACT_TEMPLATES, templates);
        commit(types.SET_LOADING, false);
        return response.data;
    }).catch(error => {
        commit(types.SET_LOADING, false);
        throw error;
    });
};

export const ActionDoUploadContractImage = ({ commit }, formData) => {
    commit(types.SET_LOADING, true);
    return services.api.request({
        url: "contract-templates/upload-image",
        method: "post",
        data: formData,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    }).then(response => {
        commit(types.SET_LOADING, false);
        return response.data;
    }).catch(error => {
        commit(types.SET_LOADING, false);
        throw error;
    });
};
